import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import GradientButton from "../gradient-button";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: "98%",
  background: "#171717",
  textAlign: "left",
  borderRadius: "12px",
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.02)",
  },
}));

export const Category = styled(Typography)({
  color: darkColors.buttonTop,
  //   marginBottom: "8px",
  textAlign: "center",
  //   pt,
});

// TutorialCard component
const TutorialCard = ({
  id,
  category,
  title,
  description,
  image,
  isMediumScreen,
  onClick,
}) => {
  return (
    <StyledCard>
      <CardMedia
        component="img"
        height="200"
        image={image}
        alt="Tutorial landscape"
        sx={{ objectFit: "cover" }}
      />
      <CardContent sx={{ p: 3, mb: 1 }}>
        <Box
          sx={{
            background: darkColors.navbarBlack,
            width: 110,
            // px: 2,
            mb: 2,
            py: 1,
            borderRadius: 99,
          }}
        >
          <Category fontSize={fontSizes.body} sx={{ fontWeight: 700 }}>
            {category}
          </Category>
        </Box>
        <Typography
          fontSize={fontSizes.heading2}
          fontFamily="MontserratBold"
          sx={{
            color: "white",
            mb: 2,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "3em", // keeps consistent height even if shorter
          }}
        >
          {title}
        </Typography>
        <Typography
          fontSize={fontSizes.body}
          sx={{
            color: "#9B9B9B",
            mb: 3,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "4.5em", // consistent space
          }}
        >
          {description}
        </Typography>
        <GradientButton
          variant="contained"
          text={"READ MORE"}
          py={isMediumScreen ? 1 : 1.3}
          width={isMediumScreen ? "100%" : 200}
          onClick={() => onClick(id)}
        />
      </CardContent>
    </StyledCard>
  );
};

export default TutorialCard;
